export function ManufacturerOutlinedIcon() {
  return (
    <svg width="48" height="44" viewBox="0 0 48 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14954_10899)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.886 1.76226V28.1558H35.114L29.5529 19.199L24 28.1477L18.4389 19.199L12.886 28.1477L7.34944 19.199L1.77203 28.1558V42.2377H46.2198V1.76226H36.886ZM48 0V44H0V27.6627L7.34944 15.8361L12.9023 24.7929L18.4553 15.8361L24.0163 24.7929L29.5692 15.8361L35.114 24.7929V0H48Z"
          fill="black"
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_14954_10899">
          <rect width="48" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
